import {
    VIEW_USER_SUCCESS,
    VIEW_USER_ERROR
    } from "../../actionTypes/authActionTypes";
    
    const reducer = (state = {}, action) => {
      switch (action.type) {
        case VIEW_USER_SUCCESS:
          return {
            ...state,
            viewUsersData: action.payload,
          };
        case VIEW_USER_ERROR:
          return {
            ...state,
            viewUsersError: action.payload,
          };
        default:
          return state;
      }
    };
    
    export default reducer;
    